import { render, staticRenderFns } from "./OfferListAdmin.vue?vue&type=template&id=067af6fc&"
import script from "./OfferListAdmin.vue?vue&type=script&lang=js&"
export * from "./OfferListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports